export default __webpack_public_path__ + "static/media/goshen43.d7f7f823.jpg";